import { render, staticRenderFns } from "./EquipmentTransferForm.vue?vue&type=template&id=40660284"
import script from "./EquipmentTransferForm.vue?vue&type=script&lang=js"
export * from "./EquipmentTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports